import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Tooltip } from '@mui/material';
import Constants from '../../utils/constants';

export default function SelectAutoWidth(props) {

  return (
    <div>
      <Tooltip title={Constants.PAGE_HEADER.ADD_ASSIGNEE} placement='top'>
        <FormControl sx={{ m: 1, minWidth: props.minWidth || 80 }}>
          <InputLabel id="simple-select-autowidth-label">{props.inputLabel}</InputLabel>
          <Select
            labelId="simple-select-autowidth-label"
            id="simple-select-autowidth"
            value={props.value}
            onChange={props.handleChange}
            autoWidth
            label={props.inputLabel}
            renderValue={(o) => o.name}
          >
            {props.dropDownList.map((val, index) => {
              return (
                !props.showOnly || props.showOnly.includes(val.teamId) ?
                  <MenuItem key={index} value={val}>{val.name} {props.showOnly ? `(${val.team})` : ""}</MenuItem>
                  : null
              );
            })}
          </Select>
        </FormControl>
      </Tooltip>
    </div>
  );
}